/** @typedef {import('./Props').default} Props */

import { translate } from '../../../Internationalization';
import images from '../../../../config/local/images';
import LinkButton from '../../../../shared/LinkButton';
import React from 'react';

/**
 * @param {Props} props
 * @returns {JSX.Element}
 */
export default function GenericVendorsOverlay(props) {
	return (
		<section className="m-auto my-5 message message-themed-light w-3/4">
			<header className="header">
				<h2 className="title large">
					{translate(
						'agent.pages.offers.view.upgrade_table.popup.title'
					)}
				</h2>
			</header>

			<main className="w-fit m-auto">
				<ul className="list-group">
					{['add', 'first_show', 'recommended'].map((key) => (
						<li
							// eslint-disable-next-line react/no-danger
							dangerouslySetInnerHTML={{
								__html: translate(
									`${props?.userRole}.pages.offers.view.upgrade_table.popup.${key}`
								),
							}}
							key={key}
						/>
					))}
				</ul>
			</main>

			<footer className="footer">
				<LinkButton
					className="button button-icon"
					icon={images.icons.subscription}
					iconClass="icon"
					to={props.link}
				>
					{translate(
						'agent.pages.contacts.view.upgrade_table.upgrade'
					)}
				</LinkButton>
			</footer>
		</section>
	);
}
